export default {
  baseHost: 'http://77.120.2.250:8081',
  host: process.env.REACT_APP_VOLIA_API_MDW,
  tenantId: 1,
  endpoints: {
    menu: '/sb/public/dashboard/type/TV',
    list: '/sb/public/dashboard/carousel/elements/',
    profile: '/sb/customer',
    details: '/sb/public/',
    seasons: '/sb/public/videoContent/search?type=TV_SEASON&f_tenants.id=1&f_parent.id=',
    searchVod: '/sb/videoContent/search',
    searchChannel: '/sb/channel/search',
    searchVodPublic: '/sb/public/videoContent/search',
    searchChannelPublic: '/sb/public/channel/search',
    assetBookmark: '/sb/asset/bookmark',
    seriesBookmark: '/sb/tvSeries/bookmark',
    login: '/sb/login',
    logout: '/sb/logout',
    registration: '/sb/registration',
    recoverCredentials: '/sb/recoverCredentials',
    tracking: '/sb/tracking',
    favorites: '/sb/asset/favorites',
    favoritesSeries: '/sb/tvSeries/favorites',
    epg: (channelIds, startTime, endTime) =>
      `/sb/public/epg/channels?channelIds=${channelIds}&startTime=${startTime}&endTime=${endTime}&showContentUrl=false`,
    pin: '/sb/user/pin',
    checkPin: '/sb/user/pin/check',
    autoProvision: '/sb/devices/autoprovision',
    follow: '/sb/follow',
    balance: '/sb/customer/bssInfo',
    channel: '/sb/public/channel',
    program: '/sb/public/epg',
    channels: '/sb/public/channel/all',
    favoriteChannels: '/sb/channel/favorite',
    recentlyWatchedChannels: '/sb/channel/recentlyWatched',
    dynamicEPGCategories: '/sb/public/channel/favorite',
    notifications: '/sb/customer/notifications',
    user: '/sb/user',
    searchCategory: '/sb/public/category/search',
    movieDetailsUrl: (contentId, profile) => `/sb/public/asset/${contentId}/detailedUrl?profile=${profile}`,
    channelDetailsUrl: (contentId, profile) => `/sb/public/channel/${contentId}/detailedUrl?profile=${profile}`,
    epgDetailsUrl: (contentId, profile) => `/sb/public/epg/${contentId}/detailedUrl?profile=${profile}`,
    filters: '/sb/public/dictionary/search',
  },
};
